import { gql } from "@apollo/client";
import { Invoice as invoice } from "../fragments";

const FETCH_INVOICE = props => gql`
  query FetchInvoice($id: Int) {
    invoice(id: $id) {
      ${invoice(props)}
    }
  }
`;

const FETCH_INVOICES = props => gql`
  query FetchInvoices($input: InvoicesFilterInput!) {
    invoices(input: $input) {
      count
      edges {
        ${invoice(props)}
      }
    }
  }
`;

const FETCH_INVOICES_V2 = props => gql`
  query FetchInvoicesV2($input: AdvInvoiceFilterInput!) {
    invoicesV2(input: $input) {
      count
      edges {
        ${invoice(props)}
      }
      sqlQuery
    }
  }
`;

const FETCH_INVOICES_LIST = props => gql`
  query FetchInvoicesList($input: AdvInvoiceFilterInput!) {
    invoicesV2(input: $input) {
      count
      edges {
        id
        date
        company {
          name
          code
          invoiceCode
        }
        type {
          id
          description
        }
        approved
        contact {
          name
          img
        }
        companyName
        number
        proforma
        reference
        currency {
          code
        }
        invoiceTotals
        dueDate
      }
      sqlQuery
    }
  }
`;

// Minimal lookup used to resolve a human reference (e.g. "WCA19105") to the
// numeric invoice id so URLs like /invoice/WCA19105 can redirect. The prefix
// ("WCA") scopes the search to a company and the digits ("19105") match the
// invoice number.
const FETCH_INVOICE_ID_BY_REFERENCE = gql`
  query FetchInvoiceIdByReference($input: AdvInvoiceFilterInput!) {
    invoicesV2(input: $input) {
      count
      edges {
        id
        number
      }
    }
  }
`;

const FETCH_INVOICE_INSTANCE = gql`
  query FetchInvoiceInstance($input: InvoiceInstanceInput!) {
    invoiceInstance(input: $input) {
      amount
      consigneeSplit
      consigneeSplitRate
      customs
      description
      discount
      invoiceId
      nominalId
      ref
      source
      tax
      taxAmount
      success
      error
    }
  }
`;

export {
  FETCH_INVOICE,
  FETCH_INVOICES,
  FETCH_INVOICES_V2,
  FETCH_INVOICE_INSTANCE,
  FETCH_INVOICES_LIST,
  FETCH_INVOICE_ID_BY_REFERENCE,
};
